import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { useTheme } from "@mui/system";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import FileUpload from "./FileUpload";
import { useDispatch } from "react-redux";
import { showSnackbar } from "../../../redux/slices/snackbar";
import { Download } from "@mui/icons-material";
import { API_BASE_URL } from "../../../config";

const ITEM_HEIGHT = 62;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
    },
  },
};

const initialFormState = {
  nome: "",
  descrizione: "",
  fonte: {},
  link: "",
  idUidFile: "",
  tipo: {},
  tipoObbligatorio: {},
  statoAssicurativo: {},
  tipoCliente: {},
  bonificoObbligatorio: {},
  dataScadenzaMora: {},
  idStatoRichiesta: {},
  tipologie: {},
  autoGenerati: {},
};

const DocumentoModale = ({
  open,
  setOpen,
  iduid,
  onRefresh,
  addDocumentoToRows,
  modifyDocumento,
  rows,
}) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [loadingPage, setLoadingPage] = useState(true);
  const [file, setFile] = useState(null);
  const [form, setForm] = useState(initialFormState);
  const [errors, setErrors] = useState({});
  const [savedLink, setSavedLink] = useState("");
  const [savedIdUidFile, setSavedIdUidFile] = useState("");

  // Snackbar helper
  const handleSnackbar = (message, severity) => {
    dispatch(showSnackbar({ message, severity }));
  };

  // Reset and close modal
  const handleClose = () => {
    setForm(initialFormState);
    setFile(null);
    setErrors({});
    setOpen(false);
    setSavedLink("");
    setSavedIdUidFile("");
  };

  // Handle file upload (for fonte === 3)
  const handleFileUpload = (files) => {
    setFile(files[0]);
  };

  // Fetch document details
  const documentiGetDetails = async (iduid) => {
    const token = sessionStorage.getItem("token");
    try {
      const response = await fetch(`${API_BASE_URL}/api/documentiGetDetails`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          token,
          data: { idUID: iduid },
        }),
      });
      const responseData = await response.json();
      if (responseData.status === -1) return navigate("/auth/sign-in");
      if (responseData.status === 0) return navigate("/private");

      const doc = responseData.data[0];
      setForm({
        iduid: doc.iduid,
        nome: doc.nome,
        descrizione: doc.descrizione,
        fonte: { dataset: doc.fonte[0].dataset, value: doc.fonte[0].value },
        link: doc.link || "",
        idUidFile: doc.idUidFile || "",
        tipo: { dataset: doc.tipo[0].dataset, value: doc.tipo[0].value },
        tipologie: {
          dataset: doc.tipologie[0].dataset,
          value: doc.tipologie[0].value,
        },
        tipoObbligatorio: {
          dataset: doc.tipoObbligatorio[0].dataset,
          value: doc.tipoObbligatorio[0].value,
        },
        statoAssicurativo: {
          dataset: doc.statoAssicurativo[0].dataset,
          value: doc.statoAssicurativo[0].value,
        },
        tipoCliente: {
          dataset: doc.tipoCliente[0].dataset,
          value: doc.tipoCliente[0].value,
        },
        bonificoObbligatorio: {
          dataset: doc.bonificoObbligatorio[0].dataset,
          value: doc.bonificoObbligatorio[0].value,
        },
        dataScadenzaMora: {
          dataset: doc.dataScadenzaMora[0].dataset,
          value: doc.dataScadenzaMora[0].value,
        },
        idStatoRichiesta: {
          dataset: doc.idStatoRichiesta[0].dataset,
          value: doc.idStatoRichiesta[0].value,
        },
        autoGenerati: {
          dataset: doc.autoGenerati[0].dataset,
          value: doc.autoGenerati[0].value,
        },
      });
      setSavedLink(doc.link || "");
      setSavedIdUidFile(doc.idUidFile || "");
      setLoadingPage(false);
    } catch (error) {
      console.log(error);
      return error;
    }
  };

  // Handle form field changes
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "nome") {
      setErrors((prevErrors) => ({
        ...prevErrors,
        nome: false,
      }));
    }

    if (name === "tipologia") {
      setForm((prev) => ({
        ...prev,
        tipologie: { ...prev.tipologie, value },
      }));
    } else if (name === "tipoObbligatorio") {
      setForm((prev) => ({
        ...prev,
        tipoObbligatorio: { ...prev.tipoObbligatorio, value },
      }));
    } else if (name === "statoAssicurativo") {
      setForm((prev) => ({
        ...prev,
        statoAssicurativo: { ...prev.statoAssicurativo, value },
      }));
    } else if (name === "tipoCliente") {
      setForm((prev) => ({
        ...prev,
        tipoCliente: { ...prev.tipoCliente, value },
      }));
    } else if (name === "idStatoRichiesta") {
      setForm((prev) => ({
        ...prev,
        idStatoRichiesta: { ...prev.idStatoRichiesta, value },
      }));
    } else if (name === "bonificoObbligatorio") {
      setForm((prev) => ({
        ...prev,
        bonificoObbligatorio: { ...prev.bonificoObbligatorio, value },
      }));
    } else if (name === "dataScadenzaMora") {
      setForm((prev) => ({
        ...prev,
        dataScadenzaMora: { ...prev.dataScadenzaMora, value },
      }));
    } else if (name === "tipo") {
      setFile(null);
      setForm((prev) => ({
        ...prev,
        tipo: { ...prev.tipo, value },
        fonte: { ...prev.fonte, value: value === 2 ? 1 : 0 },
        link: "",
        idUidFile: "",
        autoGenerati: { ...prev.autoGenerati, value: "" },
      }));
      setErrors((prev) => ({
        ...prev,
        idUidFile: false,
        link: false,
        autoGenerato: false,
      }));
    } else if (name === "fonte") {
      // Save current values before switching
      if (form.fonte.value === 2) setSavedLink(form.link);
      if (form.fonte.value === 3) setSavedIdUidFile(form.idUidFile);
      setFile(null);
      setForm((prev) => {
        let newForm = {
          ...prev,
          fonte: { ...prev.fonte, value },
        };
        // Restore previous value if switching back
        if (value === 2) {
          newForm.link = savedLink;
          newForm.idUidFile = savedIdUidFile;
          newForm.autoGenerati = { ...newForm.autoGenerati, value: "" };
        } else if (value === 3) {
          newForm.idUidFile = savedIdUidFile;
          newForm.link = "";
          newForm.autoGenerati = { ...newForm.autoGenerati, value: "" };
        } else if (value === 1) {
          newForm.idUidFile = savedIdUidFile;
          newForm.link = "";
        } else {
          newForm.link = "";
          newForm.idUidFile = "";
        }
        return newForm;
      });

      setErrors((prev) => ({
        ...prev,
        idUidFile: false,
        link: false,
        autoGenerato: false,
      }));
    } else if (name === "link") {
      setErrors((prev) => ({ ...prev, link: false }));
      setForm((prev) => ({
        ...prev,
        link: value,
      }));
      setSavedLink(value);
    } else if (name === "autoGenerato") {
      /* setErrors((prev) => ({ ...prev, link: false })); */
      setForm((prev) => ({
        ...prev,
        autoGenerati: { ...prev.autoGenerati, value },
      }));
    } else {
      setForm((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  // Save document
  const handleSave = async () => {
    // Error checks
    const newErrors = {
      nome: form.nome === "",
      file:
        savedIdUidFile === ""
          ? form.tipo.value === 2 && form.fonte.value === 3 && !file
          : false,
      link: form.tipo.value === 2 && form.fonte.value === 2 && !form.link,
      autoGenerato:
        form.tipo.value === 2 &&
        form.fonte.value === 1 &&
        form.autoGenerati.value === "",
    };

    setErrors(newErrors);

    // If any error, show snackbar and stop
    if (Object.values(newErrors).some(Boolean)) {
      handleSnackbar("Compila tutti i campi obbligatori.", "error");
      return;
    }

    setLoadingPage(true);
    const payload = {
      idUID: iduid,
      nome: form.nome.trim(),
      descrizione: form.descrizione.trim(),
      fonte: form.fonte.value,
      tipoObbligatorio: form.tipoObbligatorio.value,
      tipoCliente: form.tipoCliente.value,
      statoAssicurativo: form.statoAssicurativo.value,
      idStatoRichiesta: form.idStatoRichiesta.value,
      bonificoObbligatorio: form.bonificoObbligatorio.value,
      dataScadenzaMora: form.dataScadenzaMora.value,
      tipo: form.tipo.value,
      tipologia: form.tipologie.value,
      link: form.link.trim(),
      idUidFile: form.idUidFile,
      idAutoGenerato:
        form.autoGenerati.value === "" ? 0 : form.autoGenerati.value,
    };

    console.log(payload);

    if (rows !== undefined) {
      const documentoExists = (doc) => {
        return rows.some(
          (row) =>
            row.nome.trim().toLowerCase() === doc.nome.trim().toLowerCase(),
        );
      };

      /* if (documentoExists(payload)) {
        handleSnackbar("Documento già esistente, cambiare il nome", "error");
        setLoadingPage(false);
        return;
      } */
    }

    const formData = new FormData();
    const token = sessionStorage.getItem("token");

    formData.append("data", JSON.stringify(payload));
    formData.append("file", "");

    // Only append file if fonte === 3
    if (form.tipo.value === 2 && form.fonte.value === 3 && file) {
      formData.set("file", file);
    }

    formData.forEach((value, key) => {
      console.log(`${key}:`, value);
    });

    try {
      // Uncomment to enable API call
      const response = await fetch(`${API_BASE_URL}/api/documentiNewUpdate`, {
        method: "POST",
        headers: {
          authorization: "Bearer " + token,
        },
        body: formData,
      });

      const responseData = await response.json();

      if (responseData.status === -1) {
        navigate("/auth/sign-in");
      }
      if (responseData.status === 0) {
        handleSnackbar(responseData.message, "error");
        return;
      }
      if (responseData.status === 1) {
        handleSnackbar(responseData.message, "success");
        const documento = {
          ...payload,
          idUidDocumento: responseData.data.idUid,
          tipo: payload.tipo === 1 ? "Richiesto" : "Contratto",
          fonte:
            payload.fonte === 1
              ? "Autogenerato"
              : payload.fonte === 2
              ? "Link"
              : payload.fonte === 3
              ? "File"
              : "",
          abilitato: 0,
        };
        delete documento.idUID;

        if (addDocumentoToRows !== undefined && iduid === "") {
          if (!addDocumentoToRows(documento)) {
            setLoadingPage(false);
            return;
          }
        }
        if (modifyDocumento !== undefined && iduid !== "") {
          if (!modifyDocumento(documento)) {
            setLoadingPage(false);
            return;
          }
        }
      }
      setLoadingPage(false);
      handleClose();
      if (onRefresh) onRefresh();
    } catch (error) {
      console.log(error);
      handleSnackbar("Errore durante il salvataggio.", "error");
      setLoadingPage(false);
      handleClose();
    }
  };

  // Fetch details when modal opens
  useEffect(() => {
    if (open && iduid !== null) {
      setLoadingPage(true);
      documentiGetDetails(iduid);
    }
  }, [open, iduid]);

  async function download(iduid) {
    setLoadingPage(true);
    const token = sessionStorage.getItem("token");
    try {
      const res = await fetch(`${API_BASE_URL}/api/download/${iduid}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + token,
        },
        body: JSON.stringify({ token }),
      });

      // Controlla se la risposta è JSON (errore) o un file (octet-stream)
      const contentType = res.headers.get("Content-Type");

      if (contentType && contentType.includes("application/json")) {
        // È un errore JSON, quindi leggi il JSON
        const response = await res.json();
        if (response.status === 0) {
          handleSnackbar(response.message, "error");
        } else {
          handleSnackbar("Errore sconosciuto", "error");
        }
      } else {
        // È un file da scaricare
        const blob = await res.blob();
        const url = window.URL.createObjectURL(blob);

        // Prendi il nome file originale dall'header X-Filename, se esiste
        const originalFilename = res.headers.get("X-Filename") || iduid;

        const a = document.createElement("a");
        a.href = url;
        a.download = originalFilename; // usa il nome originale se disponibile
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
        handleSnackbar("File scaricato con successo", "success");
        setLoadingPage(false);
      }
    } catch (error) {
      handleSnackbar("Download Fallito", "error");
    }
  }

  return (
    <Dialog
      open={open}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: "600px",
            backgroundColor:
              theme.palette.mode === "dark" ? "#1B2635" : "#F7F9FC",
          },
        },
      }}
    >
      <DialogTitle>
        {iduid === "" ? "Aggiungi Documento" : "Modifica Documento"}
      </DialogTitle>
      <DialogContent>
        {loadingPage ? (
          <Box display="flex" justifyContent="center">
            <CircularProgress />
          </Box>
        ) : (
          <Box width="100%" mt={2}>
            <Grid container spacing={3} mb={4}>
              <Grid item sm={4} xs={12}>
                <FormControl size="small" fullWidth margin="none">
                  <InputLabel id="tipologia-label">Tipologia</InputLabel>
                  <Select
                    labelId="tipologia-label"
                    id="tipologia"
                    name="tipologia"
                    label="Tipologia"
                    value={form.tipologie.value}
                    MenuProps={MenuProps}
                    onChange={handleChange}
                  >
                    {form.tipologie.dataset?.map((el) => (
                      <MenuItem key={el.value} value={el.value}>
                        {el.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item sm={4} xs={12}>
                <TextField
                  size="small"
                  margin="none"
                  label="Nome Documento"
                  value={form.nome}
                  onChange={handleChange}
                  error={errors.nome}
                  helperText={errors.nome ? "Il nome è obbligatorio" : ""}
                  fullWidth
                  id="nome-modale"
                  name="nome"
                  style={{ minWidth: 120 }}
                />
              </Grid>
              <Grid item sm={4} xs={12}>
                <TextField
                  size="small"
                  margin="none"
                  label="Descrizione Documento"
                  value={form.descrizione}
                  onChange={(e) =>
                    setForm((prev) => ({
                      ...prev,
                      descrizione: e.target.value,
                    }))
                  }
                  fullWidth
                  id="descrizione-modale"
                  name="descrizione"
                  style={{ minWidth: 120 }}
                />
              </Grid>
            </Grid>
            <Box border="0.5px solid #656565ff" padding={4}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <FormControl size="small" fullWidth margin="none">
                    <InputLabel id="tipo-obbligatorio-label">
                      Tipo Obbligatorio
                    </InputLabel>
                    <Select
                      labelId="tipo-obbligatorio-label"
                      id="tipo-obbligatorio"
                      name="tipo-obbligatorio"
                      label="Tipo Obbligatorio"
                      value={form.tipoObbligatorio.value}
                      MenuProps={MenuProps}
                      onChange={handleChange}
                    >
                      {form.tipoObbligatorio.dataset?.map((el) => (
                        <MenuItem key={el.value} value={el.value}>
                          {el.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item sm={4} xs={12}>
                  <FormControl size="small" fullWidth margin="none">
                    <InputLabel id="tipo-cliente-label">
                      Tipo Cliente
                    </InputLabel>
                    <Select
                      labelId="tipo-cliente-label"
                      id="tipo-cliente"
                      name="tipoCliente"
                      label="Tipo Cliente"
                      value={form.tipoCliente.value}
                      MenuProps={MenuProps}
                      onChange={handleChange}
                    >
                      {form.tipoCliente.dataset?.map((el) => (
                        <MenuItem key={el.value} value={el.value}>
                          {el.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item sm={4} xs={12}>
                  <FormControl size="small" fullWidth margin="none">
                    <InputLabel id="stato-assicurativo-label">
                      Stato Assicurativo
                    </InputLabel>
                    <Select
                      labelId="stato-assicurativo-label"
                      id="stato-assicurativo"
                      name="statoAssicurativo"
                      label="Stato Assicurativo"
                      value={form.statoAssicurativo.value}
                      MenuProps={MenuProps}
                      onChange={handleChange}
                    >
                      {form.statoAssicurativo.dataset?.map((el) => (
                        <MenuItem key={el.value} value={el.value}>
                          {el.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item sm={4} xs={12}>
                  <FormControl size="small" fullWidth margin="none">
                    <InputLabel id="stato-richiesta-label">
                      Stato Richiesta
                    </InputLabel>
                    <Select
                      labelId="stato-richiesta-label"
                      id="stato-richiesta"
                      name="idStatoRichiesta"
                      label="Stato Richiesta"
                      value={form.idStatoRichiesta.value}
                      MenuProps={MenuProps}
                      onChange={handleChange}
                    >
                      {form.idStatoRichiesta.dataset?.map((el) => (
                        <MenuItem key={el.value} value={el.value}>
                          {el.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item sm={4} xs={12}>
                  <FormControl size="small" fullWidth margin="none">
                    <InputLabel id="bonifico-obbligatorio-label">
                      Bonifico Obbligatorio
                    </InputLabel>
                    <Select
                      labelId="bonifico-obbligatorio-label"
                      id="bonifico-obbligatorio"
                      name="bonificoObbligatorio"
                      label="Bonifico Obbligatorio"
                      value={
                        form.bonificoObbligatorio.value === 0
                          ? ""
                          : form.bonificoObbligatorio.value
                      }
                      MenuProps={MenuProps}
                      onChange={handleChange}
                    >
                      {form.bonificoObbligatorio.dataset?.map((el) => (
                        <MenuItem key={el.value} value={el.value}>
                          {el.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item sm={4} xs={12}>
                  <FormControl size="small" fullWidth margin="none">
                    <InputLabel id="mancata-circolazione-label">
                      Mancata Circolazione
                    </InputLabel>
                    <Select
                      labelId="mancata-circolazione-label"
                      id="mancata-circolazione"
                      name="mancataCircolazione"
                      label="Mancata Circolazione"
                      value={
                        form.dataScadenzaMora.value === 0
                          ? ""
                          : form.dataScadenzaMora.value
                      }
                      MenuProps={MenuProps}
                      onChange={handleChange}
                    >
                      {form.dataScadenzaMora.dataset?.map((el) => (
                        <MenuItem key={el.value} value={el.value}>
                          {el.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Box>
            <Box border="0.5px solid #656565ff" padding={4} mt={2}>
              <Grid container spacing={3} mb={4}>
                <Grid item xs={12}>
                  <FormControl size="small" fullWidth margin="none">
                    <InputLabel id="tipo-label">Tipo</InputLabel>
                    <Select
                      labelId="tipo-label"
                      id="tipo"
                      name="tipo"
                      label="Tipo"
                      MenuProps={MenuProps}
                      value={form.tipo.value}
                      onChange={handleChange}
                    >
                      {form.tipo.dataset?.map((el) => (
                        <MenuItem key={el.value} value={el.value}>
                          {el.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item sm={6} xs={12}>
                  {form.tipo.value === 2 && (
                    <FormControl size="small" fullWidth margin="none">
                      <InputLabel id="fonte-label">Fonte</InputLabel>
                      <Select
                        labelId="fonte-label"
                        id="fonte"
                        name="fonte"
                        label="Fonte"
                        f
                        MenuProps={MenuProps}
                        value={form.fonte.value === 0 ? 1 : form.fonte.value}
                        onChange={handleChange}
                      >
                        {form.fonte.dataset?.map((el) => (
                          <MenuItem key={el.value} value={el.value}>
                            {el.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  )}
                </Grid>

                <Grid item sm={6} xs={12}>
                  {form.fonte.value === 3 && form.idUidFile !== "" && (
                    <Box display="flex" justifyContent="center" mb={4}>
                      <Button
                        variant="contained"
                        onClick={() => download(savedIdUidFile)}
                      >
                        Scarica File
                        <Download />
                      </Button>
                    </Box>
                  )}

                  {form.tipo.value === 2 && form.fonte.value === 2 ? (
                    <TextField
                      size="small"
                      margin="none"
                      label="Link Contratto"
                      required
                      fullWidth
                      value={form.link}
                      onChange={handleChange}
                      id="link-modale"
                      name="link"
                      style={{ minWidth: 120 }}
                      error={errors.link}
                      helperText={errors.link ? "Il link è obbligatorio" : ""}
                    />
                  ) : form.tipo.value === 2 && form.fonte.value === 3 ? (
                    !file ? (
                      <Box
                        display="flex"
                        flexDirection="column"
                        gap={4}
                        width="100%"
                      >
                        <FileUpload onFileAccepted={handleFileUpload} />
                        {errors.file && (
                          <Box sx={{ color: "red", fontSize: 12 }}>
                            Il file è obbligatorio
                          </Box>
                        )}
                      </Box>
                    ) : (
                      <Box
                        sx={{
                          border: `2px dashed #ccc`,
                          padding: "20px",
                          textAlign: "center",
                          cursor: "pointer",
                          borderRadius: "4px",
                          color: errors.idUidFile ? "red" : "inherit",
                        }}
                      >
                        {file.name}
                      </Box>
                    )
                  ) : (
                    form.tipo.value === 2 &&
                    form.fonte.value === 1 && (
                      <FormControl fullWidth size="small" margin="none">
                        <InputLabel id="autoGenerato-label">
                          Documenti Autogenerati
                        </InputLabel>
                        <Select
                          labelId="autoGenerato-label"
                          id="autoGenerato"
                          name="autoGenerato"
                          label="Documenti Autogenerati"
                          MenuProps={MenuProps}
                          value={form.autoGenerati.value}
                          onChange={handleChange}
                          error={errors.autoGenerato}
                        >
                          {form.autoGenerati.dataset?.map((el) => (
                            <MenuItem key={el.value} value={el.value}>
                              {el.label}
                            </MenuItem>
                          ))}
                        </Select>
                        {errors.autoGenerato && (
                          <FormHelperText sx={{ color: "red" }}>
                            Il documento autogenerato è obbligatorio
                          </FormHelperText>
                        )}
                      </FormControl>
                    )
                  )}
                </Grid>
              </Grid>
            </Box>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleClose}
          color="primary"
          sx={{ marginRight: "8px" }}
        >
          Chiudi
        </Button>
        <Button
          onClick={handleSave}
          variant="contained"
          sx={{ marginRight: "8px" }}
          disabled={loadingPage}
        >
          Salva
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DocumentoModale;
